import { render, staticRenderFns } from "./ControlList.vue?vue&type=template&id=b9c985c2&scoped=true"
import script from "./ControlList.vue?vue&type=script&lang=js"
export * from "./ControlList.vue?vue&type=script&lang=js"
import style0 from "./ControlList.vue?vue&type=style&index=0&id=b9c985c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c985c2",
  null
  
)

export default component.exports